import React, { forwardRef, memo } from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { Video as SmartVideo } from '@beef/smart-kit';
import { withAnalyticsVideo } from "../../hocs";
import { Title } from "../Title";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var _Video = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
    text = _ref.text,
    src = _ref.src,
    alt = _ref.alt,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    youtube = _ref.youtube,
    rutubeId = _ref.rutubeId,
    poster = _ref.poster,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-t-id": "components-Video"
  }, title && /*#__PURE__*/React.createElement(Title, {
    isWithSubtitle: !!text
  }, title), text && /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    color: "grey60",
    size: "size4-r"
  }, text), /*#__PURE__*/React.createElement(SmartVideo, {
    alt: alt,
    autoplay: autoplay,
    onClick: onClick,
    poster: poster,
    rutubeId: rutubeId,
    src: src,
    youtubeId: youtube
  }));
});
export var Video = withAnalyticsVideo( /*#__PURE__*/memo(_Video));